<template>
  <div class="flex gap-3 pb-4 border-b dark:border-gray-700 last:border-0">
    <NuxtLink :to="$localePath({ name: 'product-slug', params: { slug: item.product.slug } })" class="shrink-0 relative" @click="handleLinkClick">
      <img 
         v-if="item.product.image"
        :src="item.product.image.url" 
        :alt="item.product.name" 
        class="w-28 h-28 object-cover rounded-lg bg-gray-100 dark:bg-gray-800" 
        loading="lazy" 
      />
      <img 
        v-else
        src="/img/placeholder.jpg" 
        alt="No image available" 
        class="w-28 h-28 object-cover rounded-lg bg-gray-100 dark:bg-gray-800" 
        loading="lazy" 
      />
    </NuxtLink>
    <div class="flex-1 min-w-0 flex flex-col">
      <NuxtLink :to="$localePath({ name: 'product-slug', params: { slug: item.product.slug } })" @click="handleLinkClick">
        <h5 class="font-medium text-sm text-gray-900 dark:text-gray-100 hover:text-primary-600 dark:hover:text-primary-400 transition-colors line-clamp-2 mb-2">
          {{ item.product.name }}
        </h5>
      </NuxtLink>
      <ProductVariantSummary class="text-sm text-gray-500 dark:text-gray-400 mb-3" :summary="item.product.summary" />
      <div class="text-base font-semibold mb-3">
        <PriceCompare 
          :price="item.lineTotal" 
          :oldPrice="item.lineTotalBeforeDiscount"
        />
      </div>
      <div class="flex items-center justify-between mt-auto">
        <QuantityInput 
          class="max-w-[130px]"
          :model-value="item.quantity" 
          @update:model-value="(qty: number) => emit('update:quantity', qty)"
          :min="1"
          :max="item.product.stock"
        />
        <UButton 
          color="error" 
          variant="ghost" 
          size="xs" 
          @click="emit('remove')" 
          aria-label="Remove from cart"
          title="Remove"
        >
          <Icon name="i-heroicons-x-mark" class="w-4 h-4" />
        </UButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CartItem } from '~/types'
import QuantityInput from '~/components/molecules/QuantityInput.vue'
import PriceCompare from './PriceCompare.vue';
import ProductVariantSummary from '~/components/molecules/ProductVariantSummary.vue'

defineProps<{
  item: CartItem,
  currency: string
}>()

const emit = defineEmits<{
  (e: 'update:quantity', qty: number): void
  (e: 'remove'): void
  (e: 'link-click'): void
}>()

function handleLinkClick() {
  emit('link-click')
}
</script>
